import type { Ref } from 'vue'
import { computed } from 'vue'
import useSWRV from 'swrv'

import { container, TYPES } from '@/libs/di/inversify.config'
import { captureException } from '@sentry/vue'

import type { Match } from '@/types/app'
import { isClientError } from '@/libs/utilities/CustomErrors'

export const useDiagnosisSummary = (match: Ref<Maybe<Match>>) => {
  const userId = computed(() => match.value?.user.id)
  const fetcher = async () => {
    if (
      userId.value == null ||
      match.value?.user.diagnosisResult == null // matchの診断が見えなきゃsummaryもつくれないので
    ) {
      return null
    }
    try {
      const value = await container
        .get(TYPES.UserUsecase)
        .getDiagnosisSummary(userId.value)

      return value ?? null
    } catch (e) {
      if (!isClientError(e)) {
        captureException(e)
      }

      return null
    }
  }
  const { data, isValidating: loading } = useSWRV(
    () => (userId.value ? `getDiagnosisSummary/${userId.value}` : null),
    fetcher
  )

  const diagnosisSummary = computed(() => data.value ?? undefined)

  return {
    diagnosisSummary,
    loading,
  }
}
